module.exports = __webpack_public_path__ + "static/img/bgg.b8ec34d1.png";